import React, { useState } from 'react';
import {useLocation} from "react-router-dom"; 
import {useEffect} from "react"; 
import {Link} from "react-router-dom"; 
import WhatsAppSupportLink from "../components/WhatsAppSupportLink"; 
import {
  FaPaypal,
  FaUniversity,
  FaExchangeAlt,
  FaBitcoin,
  FaExclamationTriangle,
} from 'react-icons/fa';
import '../App.css';
import Logo from "../assets/Logo"; 
import {useContext} from "react"; 
import SpinnerLogo from  "../components/SpinnerLogo"; 
import SmartsupChat from "../components/SmartsupChat"; 
import Footer from "../components/Footer"; 
import DashboardHeader from "../components/DashboardHeader"; 
import {AuthContext} from "../AuthContext"; 

const WithdrawPage = () => {
  const SUPPORT_LINK = import.meta.env.VITE_SUPPORT_LINK; 
  const message = "Hello, I need help with my withdrawal. Can you assist me ? "; 
   const [withdrawalMethod, setWithdrawalMethod] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [withdrawalAmount, setWithdrawalAmount] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [userBalance, setUserBalance] = useState(0); 
  const currentLocation  = useLocation(); 
  const {user} = useContext(AuthContext); 
  // Form fields state
  useEffect(()=>{
	 const investmentDetails = JSON.parse(localStorage.getItem("userInvestmentDetails")); 
	 const balance = investmentDetails.balance + investmentDetails.daily_profit + investmentDetails.weekly_profit; 
	 setUserBalance(balance); 
  },[])
  const [formFields, setFormFields] = useState({
    paypalEmail: '',
    bankAccountNumber: '',
    bankName: '',
    iban: '',
    swiftBic: '',
    bitcoinAddress: '',
  });

  const handleWithdrawalMethod = (method) => {
    setWithdrawalMethod(method);
    setShowError(false);
    setErrorMessage('');
  };

  const handleInputChange = (e) => {
    setFormFields({
      ...formFields,
      [e.target.name]: e.target.value,
    });
    setErrorMessage('');
  };

  const handleWithdrawalSubmit = () => {
    // Validation
    if (withdrawalAmount === '' || withdrawalAmount <= 0) {
      setErrorMessage('Please enter a valid withdrawal amount.');
      return;
    }

    if (withdrawalAmount > userBalance) {
      setErrorMessage('Withdrawal amount exceeds available balance.');
      return;
    }

    if (!withdrawalMethod) {
      setErrorMessage('Please select a withdrawal method.');
      return;
    }

    // Check required fields based on withdrawal method
    switch (withdrawalMethod) {
      case 'paypal':
        if (!formFields.paypalEmail) {
          setErrorMessage('Please enter your PayPal email.');
          return;
        }
        break;
      case 'bank':
        if (!formFields.bankAccountNumber || !formFields.bankName) {
          setErrorMessage('Please enter your bank account details.');
          return;
        }
        break;
      case 'wire':
        if (!formFields.iban || !formFields.swiftBic) {
          setErrorMessage('Please enter your wire transfer details.');
          return;
        }
        break;
      case 'bitcoin':
        if (!formFields.bitcoinAddress) {
          setErrorMessage('Please enter your Bitcoin wallet address.');
          return;
        }
        break;
      default:
        break;
    }

    // If validation passes, proceed with loading and simulate processing
    setLoading(true);
    setShowError(false);
    setErrorMessage('');

    // Simulate a delay to show loading spinner
    setTimeout(() => {
      setLoading(false);
      setShowError(true);
    }, 10000); // Simulate a 10-second loading delay
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 gap-[20%]">
		<DashboardHeader userName={user} kycStatus={"Verified"} accountStatus={"Active"} />
      {/* Branding */}
      <header className="text-center mb-8 flex items-center flex flex-col">
				<Logo size = "60" />
            <h1 className="text-[1.5rem] font-bold">InsightExchangeCo</h1>
      </header>

      <div className="w-full max-w-lg p-6 bg-white rounded-lg shadow-lg">
		  
        <h1 className="text-3xl font-bold text-center mb-6">Withdrawal</h1>
        {/* User Balance */}
        <div className="mb-4 text-right">
          <p className="text-gray-700 font-semibold text-center text-xl">
            Account Balance <p className="text-blue-500">${userBalance}</p>
          </p>
        </div>


        {loading ? (
          // Loading spinner
          <div className="flex flex-col items-center justify-center">
				  <SpinnerLogo />
            <p className="text-xl font-semibold">Processing your withdrawal...</p>
          </div>
        ) : !showError ? (
          <>
            {/* Error Message */}
            {errorMessage && (
              <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
                {errorMessage}
              </div>
            )}

            {/* USD Withdrawal Amount Input */}
            <div className="mb-6">
              <label className="block text-md font-semibold mb-2 text-center">
                Enter Amount $USD
              </label>
              <input
                type="number"
                value={withdrawalAmount}
                onChange={(e) => {
                  setWithdrawalAmount(e.target.value);
                  setErrorMessage('');
                }}
                placeholder="Enter amount"
                className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            {/* Withdrawal Method Selection */}
            <div className="flex flex-wrap justify-around mb-6">
              <button
                onClick={() => handleWithdrawalMethod('paypal')}
                className={`flex flex-col items-center p-4 m-2 border ${
                  withdrawalMethod === 'paypal' ? 'border-blue-500' : 'border-gray-300'
                } rounded-lg transition-colors hover:shadow-lg`}
              >
                <FaPaypal size={40} className="text-blue-500" />
                <span className="mt-2 font-semibold">PayPal</span>
              </button>
              <button
                onClick={() => handleWithdrawalMethod('bank')}
                className={`flex flex-col items-center p-4 m-2 border ${
                  withdrawalMethod === 'bank' ? 'border-blue-500' : 'border-gray-300'
                } rounded-lg transition-colors hover:shadow-lg`}
              >
                <FaUniversity size={40} className="text-green-500" />
                <span className="mt-2 font-semibold">Bank Transfer</span>
              </button>
              <button
                onClick={() => handleWithdrawalMethod('wire')}
                className={`flex flex-col items-center p-4 m-2 border ${
                  withdrawalMethod === 'wire' ? 'border-blue-500' : 'border-gray-300'
                } rounded-lg transition-colors hover:shadow-lg`}
              >
                <FaExchangeAlt size={40} className="text-yellow-500" />
                <span className="mt-2 font-semibold">Wire Transfer</span>
              </button>
              <button
                onClick={() => handleWithdrawalMethod('bitcoin')}
                className={`flex flex-col items-center p-4 m-2 border ${
                  withdrawalMethod === 'bitcoin' ? 'border-blue-500' : 'border-gray-300'
                } rounded-lg transition-colors hover:shadow-lg`}
              >
                <FaBitcoin size={40} className="text-orange-500" />
                <span className="mt-2 font-semibold">Bitcoin</span>
              </button>
            </div>

            {/* Withdrawal Form Based on Method */}
            {withdrawalMethod && (
              <div className="transition-all">
                <h2 className="text-xl font-semibold mb-4 text-center">
                  Enter {withdrawalMethod === 'bitcoin' ? 'Bitcoin Wallet' : withdrawalMethod}{' '}
                  Details
                </h2>

                {/* PayPal Details */}
                {withdrawalMethod === 'paypal' && (
                  <div>
                    <input
                      type="email"
                      name="paypalEmail"
                      value={formFields.paypalEmail}
                      onChange={handleInputChange}
                      placeholder="PayPal Email"
                      className="w-full p-3 border rounded-lg mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                )}

                {/* Bank Transfer Details */}
                {withdrawalMethod === 'bank' && (
                  <div>
                    <input
                      type="text"
                      name="bankAccountNumber"
                      value={formFields.bankAccountNumber}
                      onChange={handleInputChange}
                      placeholder="Account Number"
                      className="w-full p-3 border rounded-lg mb-4 focus:outline-none focus:ring-2 focus:ring-green-500"
                    />
                    <input
                      type="text"
                      name="bankName"
                      value={formFields.bankName}
                      onChange={handleInputChange}
                      placeholder="Bank Name"
                      className="w-full p-3 border rounded-lg mb-4 focus:outline-none focus:ring-2 focus:ring-green-500"
                    />
                  </div>
                )}

                {/* Wire Transfer Details */}
                {withdrawalMethod === 'wire' && (
                  <div>
                    <input
                      type="text"
                      name="iban"
                      value={formFields.iban}
                      onChange={handleInputChange}
                      placeholder="IBAN"
                      className="w-full p-3 border rounded-lg mb-4 focus:outline-none focus:ring-2 focus:ring-yellow-500"
                    />
                    <input
                      type="text"
                      name="swiftBic"
                      value={formFields.swiftBic}
                      onChange={handleInputChange}
                      placeholder="SWIFT/BIC"
                      className="w-full p-3 border rounded-lg mb-4 focus:outline-none focus:ring-2 focus:ring-yellow-500"
                    />
                  </div>
                )}

                {/* Bitcoin Details */}
                {withdrawalMethod === 'bitcoin' && (
                  <div>
                    <input
                      type="text"
                      name="bitcoinAddress"
                      value={formFields.bitcoinAddress}
                      onChange={handleInputChange}
                      placeholder="Bitcoin Wallet Address"
                      className="w-full p-3 border rounded-lg mb-4 focus:outline-none focus:ring-2 focus:ring-orange-500"
                    />
                  </div>
                )}

                {/* Submit Button */}
                <button
                  onClick={handleWithdrawalSubmit}
                  className="w-full py-3 bg-gradient-to-r from-blue-500 to-indigo-500 text-white font-bold rounded-lg hover:opacity-90 transition-opacity"
                >
                  Submit Withdrawal
                </button>
              </div>
            )}
          </>
        ) : (
          <div className="text-center flex flex-col items-center justify-center gap-5">
            <FaExclamationTriangle size={50} className="text-red-500 mx-auto mb-4 animate-pulse" />
            <h2 className="text-2xl font-bold mb-4">Error Processing Withdrawal</h2>
            <button
              onClick={() => setShowError(false)}
              className="w-full py-3 bg-red-500 text-white font-bold rounded-lg hover:bg-red-600 transition-colors"
            >
              Retry
            </button>
          </div>
        )}
      </div>
		<SmartsupChat />
		<Footer />
    </div>
  );
};

export default WithdrawPage;

